import { render, staticRenderFns } from "./LoanCancelModal.vue?vue&type=template&id=a8b4652c&scoped=true&"
import script from "./LoanCancelModal.vue?vue&type=script&lang=js&"
export * from "./LoanCancelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b4652c",
  null
  
)

export default component.exports